import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@material-ui/core';
import Button from 'components/CustomButtons/Button';
import GCIExceptionEntriesTable from './GCIExceptionEntriesTable';

const GCIExceptionsDialog = ({ open, user, entries, onClose, onAddException, onEditException }) => {
  if (!user) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{ style: { minWidth: 800 } }}
    >
      <DialogTitle>{user.name} — GCI Exceptions</DialogTitle>
      <DialogContent>
        <div style={{ marginBottom: 15 }}>
          <Button color="primary" onClick={() => onAddException(user)}>
            Add Exception
          </Button>
        </div>
        <GCIExceptionEntriesTable entries={entries} onEditException={onEditException} />
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

GCIExceptionsDialog.defaultProps = {
  entries: [],
  onAddException: () => {},
  onEditException: () => {}
};

export default GCIExceptionsDialog;
